module.exports = __webpack_public_path__ + "img/voie-maltee-quebec.f31ea0d3.webp";